import { render } from "./LoadingSpinner.vue?vue&type=template&id=b8dec396&scoped=true"
const script = {}

import "./LoadingSpinner.vue?vue&type=style&index=0&id=b8dec396&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8dec396"]])

export default __exports__